import { PrizeDrawService } from './PrizeHub/PrizeDraw'

export const PrizeHubService = { ...PrizeDrawService }
